module.exports = __webpack_public_path__ + "img/S-WEB-Goal-09.d74c1700.png";